import { Link } from "react-router-dom";

const footerLinks = {
  "Inspiration": [
    { label: "Living Rooms", path: "/living-room" },
    { label: "Cozy Corners", path: "/cozy-corners" },
    { label: "Style Guide", path: "/style-guide" },
  ],
  "Journal": [
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-[#EDE6DA] pt-20 pb-10">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-[#C8BAA8]">
          {/* Brand */}
          <div className="md:col-span-5">
            <Link to="/" className="inline-block mb-6 cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/c4200398-26d5-4257-a204-b2f37ee2b784.png"
                alt="Calm Spaces Journal"
                className="h-12 w-auto object-contain"
              />
            </Link>
            <p
              className="text-[#6B5E53] text-sm leading-relaxed max-w-xs mb-8"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              A visual journal of peaceful interiors, cozy corners, and warm minimal home inspiration for quieter, softer living.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: "ri-pinterest-line", href: "https://pinterest.com" },
                { icon: "ri-instagram-line", href: "https://instagram.com" },
                { icon: "ri-twitter-x-line", href: "https://twitter.com" },
              ].map((social) => (
                <a
                  key={social.icon}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-[#C8BAA8] text-[#8B8378] hover:text-[#3A3632] hover:border-[#3A3632] transition-colors cursor-pointer"
                >
                  <i className={`${social.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 gap-10">
            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4
                  className="text-[#3A3632] text-[10px] tracking-[0.3em] uppercase font-medium mb-6"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  <a id={`footer-${title}`}>{title}</a>
                </h4>
                <ul className="space-y-4">
                  {links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-[#8B8378] text-sm hover:text-[#2C2825] transition-colors cursor-pointer"
                        style={{ fontFamily: "'Inter', sans-serif" }}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <p
            className="text-[#A89A8E] text-xs"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            © 2026 Calm Spaces Journal. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="#"
              className="text-[#A89A8E] text-xs hover:text-[#3A3632] transition-colors cursor-pointer"
              rel="nofollow"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="text-[#A89A8E] text-xs hover:text-[#3A3632] transition-colors cursor-pointer"
              rel="nofollow"
            >
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
